import { createAppKit } from '@reown/appkit/react';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { mainnet, base, polygon, sepolia, baseSepolia, polygonAmoy } from '@reown/appkit/networks';
import { QueryClient } from '@tanstack/react-query';

// Query client for data fetching
export const queryClient = new QueryClient();

// Reown Project ID
const projectId = '8303063b1790537186dbfba7e31b625c';

// Determine environment
const isDevelopment = process.env.NODE_ENV === 'development';
const isPreview = window.location.hostname.includes('preview.emergentagent.com');

// Define mainnet networks
const mainnetNetworks = [mainnet, base, polygon];

// Define testnet networks
const testnetNetworks = [sepolia, baseSepolia, polygonAmoy];

// Include all networks in preview and development, mainnet-only in production
const networks = (isDevelopment || isPreview) ? [...testnetNetworks, ...mainnetNetworks] : mainnetNetworks;

// Create Wagmi Adapter
export const wagmiAdapter = new WagmiAdapter({
  projectId,
  networks
});

// Application metadata
const metadata = {
  name: 'getbitsy.ai',
  description: 'AI-powered hotel booking & Hotelogram creator economy',
  url: window.location.origin,
  icons: [window.location.origin + '/favicon.ico']
};

// Create and export AppKit modal with email + social login enabled
export const modal = createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  features: {
    analytics: true,
    email: true,
    socials: ['google', 'x', 'apple', 'discord'],
    emailShowWallets: true,
  },
  themeMode: 'light',
  themeVariables: {
    '--w3m-accent': 'hsl(198 88% 33%)',
    '--w3m-border-radius-master': '0.9rem'
  }
});

// Helper to get network display name
export function getNetworkName(chainId) {
  const names = {
    1: 'Ethereum',
    8453: 'Base',
    137: 'Polygon',
    11155111: 'Sepolia',
    84532: 'Base Sepolia',
    80002: 'Polygon Amoy'
  };
  return names[chainId] || 'Unknown Network';
}

// Helper to check if testnet
export function isTestnet(chainId) {
  const testnets = [11155111, 84532, 80002];  // Sepolia, Base Sepolia, Polygon Amoy
  return testnets.includes(chainId);
}
